import React from "react";
import { Box, Image, Text, Flex, Icon, Heading } from "@chakra-ui/react";
import { MdLocationOn } from "react-icons/md";

const DhakaMedicalCollegeCard = ({ college }) => {
 console.log("college:", college);
 return (
  <Box maxW="100%" mx="auto" p={4}>
   <Box>
    <Image
     src={college?.image1}
     alt={college?.image1}
     w="full"
     h={{ base: "200px", md: "300px" }}
     objectFit="cover"
    />

    <Flex
     direction={{ base: "column", md: "row" }}
     align="center"
     p={6}
     gap={6}
    >
     <Box>
      <Image
       src={college.image2}
       alt="DCIMCH Logo"
       w="100px"
       h="100px"
       borderRadius="md"
       border="1px solid #ddd"
       p={2}
      />
     </Box>

     <Box>
      <Heading as="h3" size="lg" color="orange.500" mb={2}>
       {college?.collegename}
      </Heading>
      <Flex align="center" color="gray.600">
       <Icon as={MdLocationOn} boxSize={5} mr={2} />
       <Text>{college?.location}</Text>
      </Flex>
     </Box>
    </Flex>
   </Box>
  </Box>
 );
};

export default DhakaMedicalCollegeCard;
